module.exports = __webpack_public_path__ + "img/icon_map_marker_white.03ec52c0.svg";